<template lang="html">
  <div class="buyzone" v-if="!isLoading">
    <div
      class="buyzone__label"
      :class="{ 'buyzone__label--danger': showChooseVariantMsg }"
    >
      <span>Variant</span>
    </div>
    <div v-if="variant" class="buyzone__spec">{{ variant.specsLine }}</div>
    <product-variants
      @input="onVariantChange"
      :variants="variants"
      v-if="variants.length > 0"
    ></product-variants>
    <inventory-status v-if="variant && variant.stock.length > 0" :stock="variant.stock"></inventory-status>
      <prices 
        :price="price"
        :your-price="yourPrice"
        :variant="variant"
        :multi="variants.length > 1" 
        :postfix="priceIncludingVat ? 'Inkl. moms' : 'Ekskl. moms'"></prices>
    <span class="js-sticky-cta"></span>
    <div class="buyzone__cta">
      <quantity-picker
        @input="onQuantityChange"
        :value="1"
        :min="1"
      ></quantity-picker>
      <button
        class="btn btn-primary buyzone__btn"
        :class="{
          'btn-cta': variant,
          'btn-loading': isBuying,
          'btn-danger': showChooseVariantMsg,
          'disabled': isSoldOut
        }"
        @click="buy"
      >
        <span v-if="isSoldOut">Udsolgt</span>
        <span v-else-if="showChooseVariantMsg">Vælg variant</span>
        <span v-else>Læg i kurv</span>
        <span
          class="btn-spinner spinner-border spinner-border-sm"
          role="status"
          aria-hidden="true"
        ></span>
      </button>
    </div>
  </div>
  <div v-else class="buyzone__loading">
    <div class="spinner-border spinner-border-sm" role="status">
      <span class="sr-only">Indlæser...</span>
    </div>
</template>

<script>
import axios from "axios";
import Vue from "vue";
import { mapState } from "vuex";
import tracking from "../js/utils/datalayer.js";
import InventoryStatus from "./components/InventoryStatus.vue";
import Prices from "./components/Prices.vue";
import ProductVariants from "./components/ProductVariants.vue";
import QuantityPicker from "./components/QuantityPicker.vue";

export default Vue.extend({
  name: "BuyZone",
  components: {
    QuantityPicker,
    InventoryStatus,
    Prices,
    ProductVariants
  },
  props: [],
  data() {
    return {
      variants: [],
      quantity: 1,
      variant: null,
      price: "",
      yourPrice: null,
      stock: [],
      hasParams: false,
      isBuying: false,
      isLoading: true,
      showChooseVariantMsg: false,
      priceIncludingVat: true
    };
  },
  created() {
    // Get dictionaries
    this.$store.dispatch("dictionary");

    axios
      .get("/umbraco/surface/ProductsApi/GetProductData", {
        params: {
          productId: window.umbracoContext.productId
        }
      })
      .then((response) => {
        this.variants = response.data.productVariants;
        this.price = response.data.price;
        this.yourPrice = response.data.yourPrice;
        this.isLoading = false;
        this.priceIncludingVat = response.data.showPricesIncVat;
        this.items = response.data.items;
        this.$nextTick(() => {
          this.stickyCta();
        });
      })
      .catch((error) => {
        console.error(error); // todo
      });

    // Avoid showing modal if no variant is selected
    document.querySelector(".js-toggle-favorite-modal")?.addEventListener("click", (e) => {
      if (!this.variant) {
        this.showChooseVariantMsg = true;
        e.preventDefault();
      } else {
        $('#rememberModal').modal();
      }
    });
  },
  methods: {
    onQuantityChange(quantity) {
      this.quantity = quantity;
    },
    onVariantChange(variant) {
      if(variant){
        this.variant = variant;
        this.showChooseVariantMsg = false;
        this.updateFavoriteButton(variant);
        if(variant.name){
          document.querySelector(".product__title span").textContent = variant.name;  
        }
      }
      tracking.viewItem(this.trackingItem);
    },
    buy() {
      if (!this.variant) {
        this.showChooseVariantMsg = true;
        return;
      }
      tracking.addToCart(this.trackingItem, this.quantity);
      this.isBuying = true;
      axios
        .post("/umbraco/surface/cart/add", {
          contextId: window.umbracoContext.id,
          productIds: this.variant.id,
          quantity: this.quantity
        })
        .then((response) => {
          if (response.status === 200) {            
            window.dispatchEvent(new CustomEvent("cart-update", { detail: { productId: this.variant.id, quantity: this.quantity }}));
            this.isBuying = false;
          }
        })
        .catch((error) => {
          console.error(error); // todo
        });
    },
    updateFavoriteButton(variant) {
      const $addElem = $(".js-add-favorite");
      const $removeElem = $(".js-remove-favorite");
      $addElem.attr("data-item-id", variant.id);
      $removeElem.attr("data-item-id", variant.id);
      $addElem.toggleClass("d-none", variant.isFavorite);
      $removeElem.toggleClass("d-none", !variant.isFavorite);
    },
    stickyCta() {
      const $stickyCta = document.querySelector(".js-sticky-cta");
      const $cta = document.querySelector(".buyzone__cta");
      const io = new IntersectionObserver(
        (entries) => {
          if (entries[0].boundingClientRect.top >= 0) {
            $cta.classList.toggle(
              "buyzone__cta--sticky",
              !entries[0].isIntersecting
            )
          }
        },
      );
      io.observe($stickyCta);
    }
  },
  computed: {
    ...mapState(["dict"]),
    isSoldOut() {
      if(this.variant) {
        return !this.variant.inStock
      } else {
        return this.variants.length > 0 && !this.variants.some(variant => variant.inStock)
      } 
    },
    trackingItem() {
      if(this.variant){
        return this.items.find(item => item.item_id === this.variant.id);
      } else {
        return { ...this.items[0], item_variant: "" };
      }
    }
  }
});
</script>
